<template>
    <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
        <button
            @click="$emit('edit', row)"
            v-if="config.actions.edit"
            :disabled="config.actions.edit && config.actions.edit.disabled"
            type="button"
            class="btn btn-sm btn-transparent"
            aria-label="Edit"
        >
            <span class="icon icon-lg icon-glyphicons-basic-pencil"></span>
        </button>
        <button
            @click="$emit('delete', row)"
            v-if="config.actions.delete"
            :disabled="config.actions.delete && config.actions.delete.disabled"
            type="button"
            class="btn btn-sm btn-transparent"
            aria-label="Remove"
        >
            <span class="icon icon-lg icon-glyphicons-basic-bin"></span>
        </button>
        <button
            v-for="action in config.customActions"
            :disabled="action && action.disabled"
            :key="action.event"
            @click="$emit('customEvent', { name: action.event, data: row})"
            type="button"
            class="btn btn-sm btn-transparent custom-action-btn mr-1"
        >
            {{ action.name }}
        </button>
        <!-- Info Message -->
        <div v-if="config.validCondition && !row[config.validCondition]" class="vert-center-parent ml-1">
            <span
                class="icon icon-lg icon-glyphicons-basic-circle-info text-danger"
                data-toggle="tooltip"
                data-placement="top"
                title="Information Required"
            ></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseTableActions",
    props: {
        config: {
            type: Object,
            required: true
        },
        row: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>

.custom-action-btn {
    text-transform: uppercase;
    font-weight: 700;
    font-size: 0.65rem;
    white-space: nowrap;
}
</style>